import React, { useContext } from "react";
import BqnContext from "common/BqnContext";
import styled from "styled-components";
import SelectAutocomplete from "./SelectAutocomplete";

export const SelectWrapper = styled.div`
  width: 220px;
  height: 20px;
  position: relative;
  .MuiAutocomplete-root input {
    background-color: transparent;
  }

  .material-icons {
    font-size: 20px;
    margin-top: 4px;
  }
`;

export function BqnSelector() {
  const {bqnId, loadClusterBqn, clusterStatus, bqns, loginBqnId, setBqnId} = useContext(BqnContext);

  let options = [];
  if (clusterStatus?.mode === "standalone") {
    options = [
      {
        label: `BQN ${clusterStatus.bqnId}`,
        value: Number(clusterStatus.bqnId),
      },
    ];
  } else if (bqns) {
    options = [
      {
        label: "Cluster",
        value: "all",
      },
      ...bqns.map((item) => ({
        label: `BQN ${item.bqnId}${item.hostname ? `: ${item.hostname}` : ""}`,
        value: Number(item.bqnId),
        disabled: item.function === "offline",
        icon: Number(item.bqnId) === Number(loginBqnId) ? "person" : null,
      })),
    ];
  }

  if (clusterStatus?.mode === "standalone") {
    return null;
  }

  return (
    <SelectWrapper id="bqn-selector">
      <SelectAutocomplete
        title="Bqns"
        name="bqns"
        icon="storage"
        selected={bqnId === "all" ? {
          label: "Cluster",
          value: "all",
        } : options.find(option => option.value.toString() === bqnId.toString())}
        onChange={(value) => {
          setBqnId(value);
        }}
        options={options}
        disableClearable={true}
        getOptionDisabled={(option) => option.disabled}
        onOpen={() => {
          loadClusterBqn();
        }}
      />
    </SelectWrapper>
  );
}
